import React from 'react';
import EdgeRenderer, { ArrowheadDefs } from '../../EdgeRenderer';
import { HiddenConnectionLines, FadeGradientDefs } from '../../HiddenConnectionLines';

const CanvasEdgesLayer = ({
  isFocusMode,
  edgesToRender,
  selectedEdge,
  reconnectingEdge,
  tasksToRender,
  handleEdgeClick,
  handleEdgeArrowDragStart,
  displayTasks,
  displayPositions,
  nodeDimensions,
  hiddenConnections,
}) => (
  <svg className="flowchart__edges">
    <ArrowheadDefs />
    {isFocusMode && <FadeGradientDefs />}

    <EdgeRenderer
      edges={edgesToRender}
      selectedEdge={selectedEdge}
      reconnectingEdgeId={reconnectingEdge?.id ?? null}
      tasks={tasksToRender}
      onEdgeClick={handleEdgeClick}
      onEdgeArrowDragStart={handleEdgeArrowDragStart}
    />

    {isFocusMode && (
      <HiddenConnectionLines
        tasks={displayTasks}
        positions={displayPositions}
        nodeDimensions={nodeDimensions}
        hiddenConnections={hiddenConnections}
      />
    )}
  </svg>
);

export default CanvasEdgesLayer;
